import { js2xml } from 'xml-js';
import { makeObservable, observable } from 'mobx';
import MapperEntity, {
  getMeasureFromXml,
  getNoteFromXmlByNoteId,
} from '../Mapper/Mapper';
import Mapper from '../Mapper/Mapper';
import { accidentaJs2Xml, accidentalsDomD } from '../../shared/elementsViews';
import XmlDiagnosticEntity from '../XmlDiagnostic/XmlDiagnostic';
import { dpAssert, makeSVGEl } from '../../sharedTypes/helpers';
import { NoteCustomAttributes } from '../../sharedTypes/Api';
import { ManagerEntity } from '@/shared/globalFunctions';

export const XmlOptions = {
  spaces: 2,
  compact: false,
};
export enum EDIT_TYPES {
  FINGER = 0,
}
class XmlEditor {
  selectedNoteElement: Element | undefined;
  xmlNote: any;
  noteCoords: { x: number; y: number } | null = null;

  fingNumber = 0;
  fingPos: PLACEMENT = PLACEMENT.BELOW;
  fingX = 0;
  fingY = -15;

  accidentalName: string | null = null;

  renderedDomElements: any[] = [];

  constructor() {
    makeObservable(this, {
      fingNumber: observable,
      fingPos: observable,
      fingX: observable,
      fingY: observable,

      accidentalName: observable,
    });
  }

  elementsWasAdded() {
    return this.renderedDomElements.length > 0;
  }

  selectNote(noteEl: HTMLElement, noteId: string) {
    this.selectedNoteElement = noteEl;
    // get use element and x, y coords
    const use = this.selectedNoteElement.children[0].children[0];
    const x = (use.attributes as any).x.value;
    const y = (use.attributes as any).y.value;
    this.noteCoords = {
      x: parseInt(x),
      y: parseInt(y),
    };

    this.xmlNote = getNoteFromXmlByNoteId(MapperEntity.xmlObject, noteId);
  }
  applyChangesForCurrNote() {
    this.syncCurrentValuesWithXmlNote();
  }
  syncCurrentValuesWithXmlNote() {
    const fingNumber = this.fingNumber;
    const fingPos = this.fingPos;
    const fingX = this.fingX;
    const fingY = this.fingY;
    dpAssert(this.selectedNoteElement);
    if (fingNumber != 0) {
      const fingering = deepCopy(fingeringStatic);
      changeFingering(fingering, fingNumber, fingX, fingY, fingPos);
      let notations = this.xmlNote.elements.find(
        (el: any) => el.name === 'notations'
      );
      if (!notations) {
        notations = deepCopy(notationsStatic);
        this.xmlNote.elements.push(notations);
      }
      if (notations) {
        const technical = notations.elements.find(
          (el: any) => el.name === 'technical'
        );
        if (technical) {
          if (technical.elements) {
            technical.elements = technical.elements.filter(
              (e: any) => e.name && e.name !== 'fingering'
            );
          } else {
            technical.elements = [];
          }
          technical.elements.push(fingering);
        } else {
          const technical = deepCopy(technicalStatic);
          removePropertyFromObjects(technical, 'name', 'fingering');
          technical.elements.push(fingering);
          notations.elements.push(technical);
        }
      }
      this.renderDomFing(fingNumber);
    } else {
      this.removeFingsFromXml();
    }
    this.syncAccidWithXmlNote();
  }
  // not used now
  autoFixDuplicateNotes(xmlRoot: any) {
    dpAssert(ManagerEntity.core);
    const extraNotes = XmlDiagnosticEntity.getExtraNotes();
    const measureIndexes = Object.keys(extraNotes);
    for (const measureIndex of measureIndexes) {
      const measure = ManagerEntity.core._timemap[parseInt(measureIndex)];
      const xmlMeasure = getMeasureFromXml(xmlRoot, measure.indexInXmlParent);
      const noteIndexesToDelete = [];
      for (const note of extraNotes[measureIndex]) {
        noteIndexesToDelete.push((note.midi as any).indexInXmlParent);
      }
      const noteElements = xmlMeasure.elements.filter(
        (e: any) => e.name === 'note'
      );
      const noteElementsFiltered = [];
      for (let ind = 0; ind < noteElements.length; ind++) {
        if (!noteIndexesToDelete.includes(ind)) {
          noteElementsFiltered.push(noteElements[ind]);
        }
      }
      const elementsCopy = [];
      for (let ind = 0; ind < xmlMeasure.elements.length; ind++) {
        const el = xmlMeasure.elements[ind];
        if (el.name != 'note') {
          elementsCopy.push(el);
        } else {
          if (noteElementsFiltered.includes(el)) {
            elementsCopy.push(el);
          } else {
            console.log('not contain');
          }
        }
      }
      xmlMeasure.elements = elementsCopy;
    }
    this.RenderXml();
  }
  renderDomFing(fingNum: number) {
    if (this.noteCoords) {
      dpAssert(ManagerEntity.core);
      const color = 'green';

      // Create the <g> element
      const gElement = makeSVGEl('g', {
        class: 'fing',
        fill: color,
        stroke: color,
      });

      // Create the <text> element
      const textElement = makeSVGEl('text', {
        x: this.noteCoords.x + 100,
        y: this.noteCoords.y + 500,
        'text-anchor': 'middle',
        'font-size': '0px',
        fill: color,
        stroke: color,
      });

      // Create the inner <tspan> elements
      const tspanOuter = makeSVGEl('tspan', {
        id: 't1aexkgc',
        class: 'text',
        fill: color,
        stroke: color,
      });
      const tspanInner = makeSVGEl('tspan', {
        'font-size': '303px',
        fill: color,
        stroke: color,
      });
      tspanInner.textContent = fingNum.toString();

      tspanOuter.appendChild(tspanInner);
      textElement.appendChild(tspanOuter);
      gElement.appendChild(textElement);

      // get id of that measure, find it, and make
      // document.getElementById
      // check
      const noteId = this.selectedNoteElement?.getAttribute('id');
      if (noteId) {
        const measureId =
          ManagerEntity.core._timemap[
            ManagerEntity.core.noteHashMap[noteId].measureIndex
          ].measureId;
        if (measureId) {
          const measureEl = document.getElementById(measureId);
          if (measureEl) {
            measureEl.appendChild(gElement);
            this.renderedDomElements.push(gElement);
          }
        }
      }
    } else {
      throw new Error('Tried to insert finger into dom without note coords');
    }
  }
  syncAccidWithXmlNote() {
    dpAssert(this.selectedNoteElement);
    if (this.xmlNote && this.accidentalName) {
      removePropertyFromObjects(this.xmlNote, 'name', 'accidental');
      const accid = accidentaJs2Xml(this.accidentalName);

      // Find type node index
      const typeIndex = this.xmlNote.elements.findIndex(
        (e: any) => e.name === 'type'
      );
      if (typeIndex !== -1) {
        // Insert after type
        this.xmlNote.elements.splice(typeIndex + 1, 0, accid);
      } else {
        this.xmlNote.elements.push(accid);
      }
    } else {
      this.removeAccidsFromXml();
    }
    this.syncAccidDomWithXmlNote();
  }
  syncAccidDomWithXmlNote() {
    const color = 'green';
    if (this.noteCoords) {
      if (this.accidentalName) {
        const pathElement = makeSVGEl('path', {
          transform: `translate(${this.noteCoords.x - 200}, ${
            this.noteCoords.y + 100
          }) scale(0.8,-0.8)`,
          fill: color,
          stroke: color,
          d: accidentalsDomD[this.accidentalName],
          noteId: this.selectedNoteElement?.getAttribute('id'),
        });

        if (this.selectedNoteElement) {
          this.selectedNoteElement.appendChild(pathElement);
          this.renderedDomElements.push(pathElement);
        }
      }
    }
  }
  getMusicxml() {
    return js2xml(MapperEntity.xmlObject, XmlOptions);
  }
  RenderXml(
    noteCustomAttributes: NoteCustomAttributes[] | undefined = undefined
  ) {
    // pass here current sample
    ManagerEntity.setMusicxml(
      this.getMusicxml(),
      false,
      undefined,
      noteCustomAttributes
    );
  }
  // remove fingering and accidentals
  removeElementsFromXml() {
    dpAssert(this.selectedNoteElement);
    const object = Mapper.xmlObject;
    const id = this.selectedNoteElement?.getAttribute('id');
    if (id) {
      const noteFromXml = getNoteFromXmlByNoteId(object, id);
      if (noteFromXml) {
        removePropertyFromObjects(noteFromXml, 'name', 'fingering');
        removePropertyFromObjects(noteFromXml, 'name', 'accidental');
      }
    }
  }
  removeFingsFromXml() {
    dpAssert(this.selectedNoteElement);
    const object = Mapper.xmlObject;
    const id = this.selectedNoteElement?.getAttribute('id');
    if (id) {
      const noteFromXml = getNoteFromXmlByNoteId(object, id);
      if (noteFromXml) {
        removePropertyFromObjects(noteFromXml, 'name', 'fingering');
      }
    }
  }
  removeAccidsFromXml() {
    dpAssert(this.selectedNoteElement);
    const object = Mapper.xmlObject;
    const id = this.selectedNoteElement?.getAttribute('id');
    if (id) {
      const noteFromXml = getNoteFromXmlByNoteId(object, id);
      if (noteFromXml) {
        removePropertyFromObjects(noteFromXml, 'name', 'accidental');
      }
    }
  }
  CancelEditing() {
    if (ManagerEntity.musicxml) {
      MapperEntity.refreshXmlObject(ManagerEntity.musicxml);
      this.renderedDomElements.forEach((el: any) => {
        el.remove();
      });
      this.resetVariables();
    }
  }
  resetVariables() {
    this.selectedNoteElement = undefined;
    this.xmlNote = null;
    this.noteCoords = null;
  }
}

const fingeringStatic = {
  type: 'element',
  name: 'fingering',
  attributes: {
    'default-x': '3',
    'default-y': '-15',
    placement: 'below',
  },
  elements: [
    {
      type: 'text',
      text: '68',
    },
  ],
};
const technicalStatic = {
  type: 'element',
  name: 'technical',
  elements: [fingeringStatic],
};
const notationsStatic = {
  type: 'element',
  name: 'notations',
  elements: [technicalStatic],
};

export function findObjectWithProperty(
  obj: any,
  propertyName: any,
  propertyValue: any
) {
  for (const key in obj) {
    if (typeof obj[key] === 'object') {
      const result: any = findObjectWithProperty(
        obj[key],
        propertyName,
        propertyValue
      );
      if (result) {
        return result;
      }
    } else if (key === propertyName && obj[key] === propertyValue) {
      return obj;
    }
  }
  return null;
}
export function findObjectsWithProperty(
  obj: any,
  propertyName: any,
  propertyValue: any,
  resultArray: any
) {
  for (const key in obj) {
    if (typeof obj[key] === 'object') {
      findObjectsWithProperty(
        obj[key],
        propertyName,
        propertyValue,
        resultArray
      );
    } else if (key === propertyName && obj[key] === propertyValue) {
      resultArray.push(obj);
    }
  }
  return resultArray.length > 0 ? resultArray : null;
}
function removePropertyFromObjects(
  obj: any,
  propertyName: any,
  propertyValue: any,
  parentObj: any = null,
  parentKey: any = null
) {
  for (const key in obj) {
    if (typeof obj[key] === 'object') {
      removePropertyFromObjects(
        obj[key],
        propertyName,
        propertyValue,
        obj,
        key
      );
    } else if (key === propertyName && obj[key] === propertyValue) {
      // If a parent object and key are provided, delete the entire object from its parent
      if (parentObj && parentKey !== null) {
        if (Array.isArray(parentObj)) {
          // For arrays, use splice to properly remove the element
          const index = parseInt(parentKey);
          if (!isNaN(index)) {
            parentObj.splice(index, 1);
          }
        } else {
          // For objects, use delete as before
          delete parentObj[parentKey];
        }
      } else {
        delete obj[key]; // If no parent provided, delete the property only
      }
    }
  }
  
  // Clean up empty arrays in the object
  cleanupEmptyArrays(obj);
  return obj;
}

// Helper function to clean up nested objects (but keep empty arrays)
function cleanupEmptyArrays(obj: any) {
  if (typeof obj !== 'object' || obj === null) {
    return;
  }
  
  for (const key in obj) {
    if (typeof obj[key] === 'object') {
      cleanupEmptyArrays(obj[key]);
      
      // Only remove empty objects (not arrays)
      if (
        typeof obj[key] === 'object' && 
        obj[key] !== null && 
        !Array.isArray(obj[key]) && 
        Object.keys(obj[key]).length === 0
      ) {
        delete obj[key];
      }
      // Keep empty arrays - don't delete them
    }
  }
}

export function deepCopy(obj: any) {
  if (typeof obj !== 'object' || obj === null) {
    return obj; // Return primitive types and null as is
  }

  const copy: any = Array.isArray(obj) ? [] : {};

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      copy[key] = deepCopy(obj[key]);
    }
  }

  return copy;
}

enum PLACEMENT {
  BELOW = 'below',
  ABOVE = 'above',
}
function changeFingering(
  fingering: any,
  val: number,
  x: number,
  y: number,
  placement: PLACEMENT
) {
  const textEl = fingering.elements.find((el: any) => el.type === 'text');
  textEl.text = val.toString();
  fingering.attributes['relative-x'] = x.toString();
  fingering.attributes['relative-y'] = y.toString();
  fingering.attributes.placement = placement;
}

export default XmlEditor;
